import script from "./RowEditList.vue?vue&type=script&setup=true&lang=js"
export * from "./RowEditList.vue?vue&type=script&setup=true&lang=js"

import "./RowEditList.vue?vue&type=style&index=0&id=132198e4&lang=scss"

const __exports__ = script;

export default __exports__